import { SET_SHOP_DETAILS, TOGGLE_IMAGE_MODAL, SET_SHOP_IMAGE_DATA } from './constants';

const initialState = {
  details: {},
  modal: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOP_DETAILS:
      return {
        ...state,
        details: action.payload
      };
    case TOGGLE_IMAGE_MODAL:
      return {
        ...state,
        modal: action.payload
      };
    case SET_SHOP_IMAGE_DATA:
      return {
        ...state,
        modal: {},
        details: {
          ...state.details,
          assetOneUrl: action.payload
        }
      };
    default:
      return state;
  }
};

export default reducer;